/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_ApplyInputs */

const es_settings_files_filters_apply = /** @type {(inputs: Settings_Files_Filters_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar filtros`)
};

const en_settings_files_filters_apply = /** @type {(inputs: Settings_Files_Filters_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply filters`)
};

/**
* | output |
* | --- |
* | "Apply filters" |
*
* @param {Settings_Files_Filters_ApplyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_apply = /** @type {((inputs?: Settings_Files_Filters_ApplyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_ApplyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_apply(inputs)
	return en_settings_files_filters_apply(inputs)
});
export { settings_files_filters_apply as "settings.files.filters.apply" }